const moment = require('moment');

module.exports = (iso, format) => {
    const date = moment(iso);

    if(format === 'short'){
        const now = moment();

        if(now.year() === date.year()){
            if(now.date() === date.date() && now.month() === date.month()){
                //Just return the time
                return date.format('LT');
            }

            //Return the Month and Date
            return date.format('MMM D');
        }

        return date.format('L');
    }

    if(format === 'long'){
        return date.format('D MMM YYYY, h:mm:ss a');
    }

    if(format === 'date'){
        return date.format('MMM D');
    }

    if(format === 'time'){
        return date.format('h:mm a');
    }

    return 'Unknown Format';
}